module.exports = __webpack_public_path__ + "img/m-bg.fc29346e.jpg";